export default "__VITE_ASSET__Bqqdn_XK__"